export default {
    setAuthStatus({commit}, status) {
        commit('setAuthStatus', status);
    },
    setToken({commit}, token) {
        commit('setToken', token);
    }
}
